var refreshingTimeline = false;

window.addEventListener("focus", (event) => {
  console.debug('window focus - ' + refreshingTimeline);
  if (!refreshingTimeline) {
    refreshTimelineData();
  }
});

document.addEventListener("focus", (event) => {
  console.debug('document focus - ' + refreshingTimeline);
  if (!refreshingTimeline) {
    refreshTimelineData();
  }
});

document.addEventListener('visibilitychange', function() {
  console.debug('visibilitychange - ' + refreshingTimeline);
  if (document.visibilityState === 'visible' && !refreshingTimeline) {
    refreshTimelineData();
  }
});

function refreshTimelineData() {
  console.debug('refreshTimelineData');
  if (wm && !wm.isEditMode()) {
    refreshingTimeline = true;
    try {
      const lastObs = Array.from(document.querySelectorAll("#timeline_steps .tl_item.tl_obs")).slice(-1)[0],
        now = new Date().getTime() / 1000;
      if (lastObs) {
        if (now - parseInt(lastObs.getAttribute('data-ts')) < 3600) {
          // console.debug('soft refresh');
          wm.refreshWindSensorsData();
          setTimeout(wm.refreshTimeline, 1000);
        } else {
          window.location.reload();
        }
      }
    } finally {
      setTimeout(() => {
        refreshingTimeline = false;
      }, 1000);
    }
  }
}
